import { render, staticRenderFns } from "./ReferralProgram.vue?vue&type=template&id=fa2b6f96&scoped=true&"
import script from "./ReferralProgram.vue?vue&type=script&lang=js&"
export * from "./ReferralProgram.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgram.vue?vue&type=style&index=0&id=fa2b6f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2b6f96",
  null
  
)

export default component.exports